///
/// EarthBrowser
///
/// Created by Matt Giger on 12/31/2025
/// Copyright (c) 2025 Geodata Labs
///

import { Database } from "@/earthbrowser/database/Database"

export type Admin2Row = {
	country_code: string
	admin1_code: string
	admin2_code: string
	name: string
}

const cBatchSize = 500

export class CountryAdmin2Table {
	public static async create(db: Database): Promise<void> {
		await db.execMany([
			{
				sql: `create table if not exists country_admin2 (
					country_code text not null,
					admin1_code text not null,
					admin2_code text not null,
					name text not null,
					primary key (country_code, admin1_code, admin2_code)
				)`
			},
			{ sql: "create index if not exists idx_country_admin2_country on country_admin2 (country_code)" },
			{ sql: "create index if not exists idx_country_admin2_country_admin1 on country_admin2 (country_code, admin1_code)" },
		])
	}

	public static async insert(rows: Admin2Row[]): Promise<void> {
		const statement = `insert into country_admin2 (country_code, admin1_code, admin2_code, name)
			values (?, ?, ?, ?)
			on conflict(country_code, admin1_code, admin2_code) do update set
				name = excluded.name`

		for (let i = 0; i < rows.length; i += cBatchSize) {
			const batch = rows.slice(i, i + cBatchSize)
			// Reference-data ingest: low priority so it yields to visible-layer reads (see LocationsTable.insert)
			await Database.db.bulkInsert(statement, batch.map(r => [r.country_code, r.admin1_code, r.admin2_code, r.name]), "low")
		}
	}

	public static async getCount(): Promise<number> {
		const rows = await Database.db.exec(
			`select count(*) as count from country_admin2`,
			[],
			"low"
		) as Array<{ count: number }>
		return Number(rows[0]?.count ?? 0)
	}
}


